<template>
  <!-- Navbar: dark shell, main links left → right (Products, Policies, Report) -->
  <nav
    ref="agentNavBar"
    class="top-0 navbar navbar-expand-md navbar-dark position-fixed start-0 end-0 navbar-shell-dark"
    style="padding-top: 0.4rem; padding-bottom: 0.4rem; z-index: 110;"
  >
    <div class="container-fluid nav-shell-container">
      <div class="d-flex align-items-center w-100 flex-nowrap gap-2 navbar-dark-inner">
        <router-link
          style="max-width: 150px; max-height: 46px; flex-shrink: 0;"
          class="navbar-brand no-underline font-weight-bolder ms-0 navbar-logo"
          :class="darkMode ? 'text-black' : 'text-white'"
          to="/catalog"
        >
          <img :src="logoSecond" style="width: 100%;" alt="" />
        </router-link>

        <span class="nav-vertical-divider nav-vertical-divider--brand d-none d-md-inline-block" aria-hidden="true" />

        <button
          class="navbar-toggler nav-toggler-dark ms-auto d-md-none"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navigation"
          aria-controls="navigation"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          id="navigation"
          class="collapse navbar-collapse flex-md-grow-1 order-3 order-md-0 w-100 w-md-auto min-w-0 pt-2 pt-md-0 navbar-collapse-dark"
        >
          <div class="flex-md-grow-1 nav-min-w-0 w-100">
          <!-- Mobile / small: stacked -->
          <div class="d-flex d-md-none flex-column gap-1 pb-2">
            <template v-for="menu in mainNavMenus" :key="'mob-' + (menu.path || menu.href)">
              <a
                v-if="!menu.list"
                :href="menu.href"
                class="nav-link nav-link-dark-flat py-2 rounded px-3"
                :class="MenuCheck(menu.path) ? 'nav-link-active' : ''"
              >{{ menu.menuName }}</a>
              <div v-else class="px-2 py-1">
                <div class="text-white-50 small mb-1">{{ menu.menuName }}</div>
                <template v-for="list in menu.list" :key="list.href || list.itemName">
                  <a
                    v-if="list.href"
                    :href="list.href"
                    class="d-block py-1 ps-2 nav-link-dark-flat small"
                    :class="MenuDetCheck(list.href) ? 'text-info' : ''"
                  >{{ list.itemName }}</a>
                </template>
              </div>
            </template>
          </div>

          <!-- Desktop: left-aligned links -->
          <div
            class="d-none d-md-flex align-items-center justify-content-start flex-grow-1 nav-desktop-rail nav-desktop-rail--start"
          >
            <ul class="navbar-nav flex-row flex-nowrap align-items-center justify-content-start gap-1 mb-0 nav-main-links">
              <li
                v-for="menu in mainNavMenus"
                :key="'nav-' + menu.path"
                class="nav-item nav-menu nav-dark-item text-center border-radius-md"
              >
                <el-dropdown
                  v-if="menu.list && menu.list.length > 0"
                  trigger="hover"
                  :show-timeout="70"
                  :hide-timeout="180"
                  popper-class="report-dropdown-popper"
                  :teleported="true"
                >
                  <span
                    class="text-white-50 no-underline nav-link nav-link-compact nav-link-modern"
                    style="cursor: pointer;"
                  >{{ menu.menuName }}</span>
                  <template #dropdown>
                    <el-dropdown-menu class="p-2 dropdown-menu-dark-nav">
                      <li v-for="list in menu.list" :key="list.href || list.itemName" class="list-unstyled">
                        <a
                          v-if="list.href"
                          :href="list.href"
                          :class="MenuDetCheck(list.href) ? 'selected' : ''"
                          class="no-underline block px-3 py-2 rounded-lg transition d-flex align-items-center dropdown-link-dark"
                        ><span>{{ list.itemName }}</span></a>
                        <span v-else class="block px-3 py-2 text-muted">{{ list.itemName }}</span>
                      </li>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
                <a
                  v-else
                  :href="menu.href"
                  class="text-white-50 no-underline nav-link nav-link-compact nav-link-modern"
                  :class="MenuCheck(menu.path) ? 'nav-link-active' : ''"
                  style="text-decoration: none;"
                >{{ menu.menuName }}</a>
              </li>
            </ul>
          </div>
          </div>
        </div>

        <!-- User: sibling of collapse (classic pattern) â€” stays visible on desktop -->
        <div
          class="nav-user-slot d-flex align-items-center flex-shrink-0 ms-md-auto order-2 order-md-0 pt-2 pt-md-0 justify-content-end"
        >
          <span class="nav-vertical-divider nav-vertical-divider--user d-none d-md-inline-block" aria-hidden="true" />

          <button
            type="button"
            class="nav-theme-trigger me-2"
            :title="themeToggleTitle"
            :aria-label="themeToggleTitle"
            @click="toggleUiTheme"
          >
            <i :class="themeIconClass" aria-hidden="true" />
          </button>

          <el-dropdown
            trigger="click"
            popper-class="report-dropdown-popper"
            :teleported="true"
            class="me-2"
            @command="handleNavbarLanguageCommand"
          >
            <span class="el-dropdown-link nav-lang-trigger">
              <span class="nav-lang-trigger__name">{{ currentLocale.toUpperCase() }}</span>
              <i class="fas fa-chevron-down nav-lang-trigger__arrow"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu class="p-2 dropdown-menu-dark-nav nav-lang-menu">
                <li v-for="lang in languages" :key="'lang-nav-' + lang.code" class="list-unstyled">
                  <el-dropdown-item
                    :command="lang.code"
                    class="nav-lang-option"
                    :class="lang.code === currentLocale ? 'is-active' : ''"
                  >
                    <span class="nav-lang-option__flag">{{ lang.flag }}</span>
                    <span class="nav-lang-option__name">{{ $t(lang.nameKey) }}</span>
                  </el-dropdown-item>
                </li>
              </el-dropdown-menu>
            </template>
          </el-dropdown>

          <el-dropdown
            v-if="navbarAccount"
            trigger="click"
            class="user-dropdown"
            popper-class="user-dropdown-popper"
            :teleported="true"
            @command="handleUserMenuCommand"
            @visible-change="handleDropdownVisibleChange"
          >
            <span class="el-dropdown-link user-trigger user-trigger--nav-dark">
              <div class="d-flex align-items-center">
                <div class="user-avatar me-2">
                  <div class="user-avatar-circle">
                    <i class="fas fa-user text-white"></i>
                  </div>
                </div>
                <div class="user-details d-none d-md-block text-start nav-min-w-0">
                  <div class="user-name text-truncate" :title="navbarAccount.fullName">
                    {{ navbarAccount.fullName }}
                  </div>
                  <div
                    v-if="navbarAccount.companyName"
                    class="user-company text-truncate"
                    :title="navbarAccount.companyName"
                  >
                    {{ navbarAccount.companyName }}
                  </div>
                </div>
                <i class="fas fa-chevron-down user-arrow ms-2" :class="{ 'arrow-rotated': isUserDropdownOpen }"></i>
              </div>
            </span>

            <template #dropdown>
              <el-dropdown-menu class="user-menu">
                <div class="p-3 ps-2">
                  <ul class="space-y-2">
                    <li>
                      <a
                        class="no-underline block px-3 py-2 rounded-lg transition d-flex align-items-center user-menu-link"
                        @click.prevent="handleUserMenuCommand('profile')"
                      >
                        <i class="fas fa-user-circle me-2"></i>
                        <span>{{ $t('profile') }}</span>
                      </a>
                    </li>

                    <li>
                      <a
                        class="no-underline block px-3 py-2 rounded-lg transition d-flex align-items-center user-menu-link"
                        @click.prevent="handleUserMenuCommand('settings')"
                      >
                        <i class="fas fa-cog me-2"></i>
                        <span>{{ $t('settings') }}</span>
                      </a>
                    </li>

                    <li>
                      <a
                        class="no-underline block px-3 py-2 rounded-lg transition d-flex align-items-center user-menu-link signout-link"
                        @click.prevent="handleUserMenuCommand('signout')"
                      >
                        <i class="fas fa-sign-out-alt me-2"></i>
                        <span>{{ $t('signOut') }}</span>
                      </a>
                    </li>

                  </ul>
                </div>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
  </nav>

  <div ref="agentBreadcrumb" class="breadcrumb-wrapper">
    <el-breadcrumb separator="/" class="breadcrumb-modern">
      <!-- <el-breadcrumb-item :to="{ path: '/home' }" class="breadcrumb-home"> -->
      <el-breadcrumb-item class="breadcrumb-home">
        <i class="fas fa-home me-1"></i>
        {{ $t('breadcrumbHome') }}
      </el-breadcrumb-item>

      <el-breadcrumb-item
        v-for="(list, index) in uniqueBreadcrumbs"
        :key="`breadcrumb-${index}-${list.label || ''}-${list.path || ''}`"
        :to="list.path ? { path: list.path } : null"
        :class="{ 'breadcrumb-last': index === uniqueBreadcrumbs.length - 1 }"
      >
        {{ list.label }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>

  <div class="agent-header-offset-spacer" aria-hidden="true" />
</template>


<script>
/*eslint-disable*/
import { imgFile } from "../../project/Source/helper";
import logoSecond from "@/assets/img/logos/progressico2white.png";
import downArrWhite from "@/assets/img/down-arrow-white.svg";
import downArrBlack from "@/assets/img/down-arrow-dark.svg"; 
import Utils from '../../project/Source/utils';
import CryptoJS from 'crypto-js';
import { changeLanguage } from '../../project/Source/lang/i18n';
import {
  getAgentTheme,
  toggleAgentTheme,
  isAgentDarkTheme,
} from '@/project/Source/agentTheme.js';

export default {
  name: "Navbar",
  props: {
    btnBackground: { type: String, default: "" },
    isBlur: { type: String, default: "" },
    darkMode: { type: Boolean, default: false }
  },

  data() {
    return {
      listMenu: [],
      uiTheme: getAgentTheme(),
      downArrWhite,
      downArrBlack,
      logo: require(`@/assets/img/logos/${imgFile}/progressico.png`),
      logoSecond,
      languages: [
        { code: 'az', nameKey: 'languageAz', flag: '🇦🇿' },
        { code: 'en', nameKey: 'languageEn', flag: '🇺🇸' },
        { code: 'ru', nameKey: 'languageRu', flag: '🇷🇺' },
        { code: 'tr', nameKey: 'languageTr', flag: '🇹🇷' }
      ],
      isUserDropdownOpen: false,
      /** Bumped so `navbarAccount` re-reads localStorage (not reactive) after login / same-tab updates */
      userStorageTick: 0
    };
  },

  computed: {
    menus() {
      return [
        {
          menuName: this.$t("productsLabel"),
          path: "catalog",
          href: "/catalog",
          list: null,
        },
        {
          menuName: this.$t("policiesLabel"),
          path: "policies",
          href: "/policies",
          list: null,
        },
        {
          menuName: this.$t("hezabatLabel"),
          path: "reports",
          href: "/reports/customers",
          list: null,
        },
      ];
    },

    mainNavMenus() {
      return this.menus;
    },

    darkModes() {
      return {
        "text-dark": this.darkMode
      };
    },
    
    currentLocale() {
      // Use reactive reference to i18n locale
      return this.$i18n.locale?.value || this.$i18n.locale || 'en';
    },
    
    /**
     * Session + user blob for the account control (name row + Profile / Settings / Sign out).
     * Accepts common API shapes; falls back to JWT-only session so the menu is not missing.
     */
    navbarAccount() {
      void this.userStorageTick;
      void this.$route.fullPath;
      const t = (k) => this.$t(k);
      const isLoggedOutUserBlob = (p) =>
        Array.isArray(p) && p.length && p[0] && (p[0].id === null || p[0].id === undefined);

      const jwtIsActive = () => {
        try {
          const enc = window.localStorage.getItem('jwt');
          if (!enc) return false;
          const raw = CryptoJS.AES.decrypt(enc, 'secret_key').toString(CryptoJS.enc.Utf8);
          if (raw == null || !String(raw).trim()) return false;
          const trimmed = String(raw).trim();
          let j;
          try {
            j = JSON.parse(trimmed);
          } catch {
            /* Ñ‚Ð¾ÐºÐµÐ½ Ð±ÐµÐ· JSON â€” Ð½Ð°Ð¿Ñ€Ð¸Ð¼ÐµÑ€ ÑÑ‹Ñ€Ð°Ñ ÑÑ‚Ñ€Ð¾ÐºÐ° JWT */
            const s = trimmed.replace(/^"+|"+$/g, '');
            return s.length > 0 && s.toLowerCase() !== 'none';
          }
          if (j === null || j === undefined) return false;
          if (typeof j === 'string') {
            const s = j.trim();
            return s.length > 0 && s.toLowerCase() !== 'none';
          }
          return true;
        } catch {
          return false;
        }
      };

      try {
        const userData = window.localStorage.getItem('user');
        let parsed = null;
        if (userData) {
          const decrypted = CryptoJS.AES.decrypt(userData, 'secret_key').toString(CryptoJS.enc.Utf8);
          if (decrypted) parsed = JSON.parse(decrypted);
        }

        if (isLoggedOutUserBlob(parsed)) {
          if (jwtIsActive()) {
            return {
              fullName: t('account'),
              companyName: '',
              _sessionOnly: true,
            };
          }
          return null;
        }

        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
          const combined = [parsed.firstName, parsed.lastName].filter(Boolean).join(' ').trim();
          const fullName =
            (parsed.fullName && String(parsed.fullName).trim()) ||
            combined ||
            (parsed.userName && String(parsed.userName).trim()) ||
            (parsed.name && String(parsed.name).trim()) ||
            (parsed.login && String(parsed.login).trim()) ||
            (parsed.email && String(parsed.email).trim()) ||
            (parsed.userId != null && String(parsed.userId) !== 'null'
              ? `${t('account')} Â· ${parsed.userId}`
              : null) ||
            (parsed.companyId != null && String(parsed.companyId) !== 'null' ? t('account') : null);

          if (fullName && String(fullName) !== 'null') {
            const companyName = parsed.companyName || parsed.company || '';
            return {
              ...parsed,
              fullName: String(fullName).trim(),
              companyName: companyName ? String(companyName) : '',
            };
          }
        }

        if (jwtIsActive()) {
          return {
            fullName: t('account'),
            companyName: '',
            _sessionOnly: true,
          };
        }
      } catch (e) {
        console.error('navbarAccount:', e);
      }
      return null;
    },
    
    isDarkUiTheme() {
      return isAgentDarkTheme(this.uiTheme);
    },
    themeIconClass() {
      return this.isDarkUiTheme ? 'fas fa-sun' : 'fas fa-moon';
    },
    themeToggleTitle() {
      return this.isDarkUiTheme
        ? this.$t('agentThemeSwitchLight')
        : this.$t('agentThemeSwitchDark');
    },
    uniqueBreadcrumbs() {
      if (!this.listMenu || !Array.isArray(this.listMenu)) {
        return [];
      }
      
      // Remove duplicates and null/undefined items
      const seen = new Set();
      const unique = [];
      
      for (const item of this.listMenu) {
        if (!item || !item.label) continue;
        
        // Create a unique key based on label and path
        const key = `${item.label}-${item.path || 'null'}`;
        
        // Only add if we haven't seen this exact combination
        if (!seen.has(key)) {
          seen.add(key);
          unique.push(item);
        }
      }
      
      return unique;
    }
  },

  methods: {
    getRoute() {
      return this.$route.path.split("/")[1];
    },
    mainWeb() {
      window.open("https://huestimates.com/", "_blank");
    },
    MenuCheck(menu) {
      return this.$route.path.split("/")[1] == menu;
    },
    MenuDetCheck(menu) {
      const pt = "/" + this.$route.path.split("/")[1] + "/" + this.$route.path.split("/")[2];
      return pt == menu;
    },
    handleLanguageChange(langCode) {
      changeLanguage(langCode);
      // Force component update to reflect language change
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    handleNavbarLanguageCommand(langCode) {
      if (!langCode) return;
      this.handleLanguageChange(langCode);
    },
    toggleUiTheme() {
      this.uiTheme = toggleAgentTheme();
    },
    
    handleUserMenuCommand(command) {
      if (command === 'profile') { 
        console.log('Profile clicked');
      } else if (command === 'settings') { 
        console.log('Settings clicked');
      } else if (command === 'signout') { 
        this.signOut();
      }
    },
    
    signOut() {
      window.localStorage.setItem(
        'jwt',
        CryptoJS.AES.encrypt(JSON.stringify('none'), 'secret_key').toString()
      );
      window.localStorage.setItem(
        'roles',
        CryptoJS.AES.encrypt(JSON.stringify([{ id: null }]), 'secret_key').toString()
      );
      window.localStorage.setItem(
        'user',
        CryptoJS.AES.encrypt(JSON.stringify([{ id: null }]), 'secret_key').toString()
      );
      window.localStorage.removeItem('medical_agent_user_branch');
      window.localStorage.removeItem('medical_agent_user_by_role');
      window.dispatchEvent(new CustomEvent('progress-auth-updated'));
      this.$router.push({ path: '/signIn/catalog' }).catch(() => {});
    },
    
    handleDropdownVisibleChange(visible) {
      this.isUserDropdownOpen = visible;
    },

    bumpNavUserReactive() {
      this.userStorageTick += 1;
    },

    syncHeaderHeights() {
      if (typeof document === "undefined") return;
      const nav = this.$refs.agentNavBar;
      const crumb = this.$refs.agentBreadcrumb;
      if (!nav) return;

      const navH = Math.ceil(nav.getBoundingClientRect().height);
      const crumbH = crumb
        ? Math.ceil(crumb.getBoundingClientRect().height)
        : 52;
      const root = document.documentElement;
      root.style.setProperty("--agent-navbar-height", `${navH}px`);
      root.style.setProperty("--agent-breadcrumb-bar-height", `${crumbH}px`);
      root.style.setProperty("--agent-header-offset", `${navH + crumbH - 3}px`);
    },
  },

  mounted() {
    this.bumpNavUserReactive();
    this.uiTheme = getAgentTheme();
    this.$nextTick(() => {
      this.syncHeaderHeights();
      window.addEventListener("resize", this.syncHeaderHeights);
    });
    this._themeListener = (e) => {
      if (e?.detail?.theme) this.uiTheme = e.detail.theme;
    };
    window.addEventListener('agent-theme-changed', this._themeListener);
    this._authStorageListener = (e) => {
      if (!e || e.type === "progress-auth-updated") {
        this.bumpNavUserReactive();
        return;
      }
      if (e.type === "storage" && (e.key === "user" || e.key === "jwt")) {
        this.bumpNavUserReactive();
      }
    };
    window.addEventListener("storage", this._authStorageListener);
    window.addEventListener("progress-auth-updated", this._authStorageListener);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.syncHeaderHeights);
    if (this._themeListener) {
      window.removeEventListener('agent-theme-changed', this._themeListener);
    }
    if (this._authStorageListener) {
      window.removeEventListener("storage", this._authStorageListener);
      window.removeEventListener("progress-auth-updated", this._authStorageListener);
    }
  },

  watch: {
    $route() {
      this.bumpNavUserReactive();
    },
    // Watch for locale changes to update the component
    '$i18n.locale.value'() {
      this.$forceUpdate();
    },
    // Also watch the locale object itself
    '$i18n.locale'() {
      this.$forceUpdate();
    }
  },

  updated() {
    this.listMenu = Utils.GetBreadcrumb();
    this.$nextTick(() => this.syncHeaderHeights());
  }
};
</script>

<style scoped src="@/assets/scss/navbar-scoped.scss" lang="scss"></style>

<style src="@/assets/scss/navbar-global.scss" lang="scss"></style>

